import { create } from 'zustand';

// The purpose of this store is to enable shared state between charts.

type Store = {
  reset: () => void;
  selectedPitchNumber: number | undefined;
  setSelectedPitchNumber: (value: number | undefined) => void;
};

export const useChartBrokerStore = create<Store>()((set) => ({
  reset: () => set(() => ({ selectedPitchNumber: undefined })),
  selectedPitchNumber: undefined,
  setSelectedPitchNumber: (value: number | undefined) => set(() => ({ selectedPitchNumber: value })),
}));
